
export const uploadContactsField = () => {
  return {
    groupName: {
      value: "",
      error: "",
    },
    groupType: {
      value: 0,
      error: "",
    },
    groupCSV: {
      value: {},
      error: "",
    },
  };
};


export const uploadContactsValidation = (uploadContactData: any) => {
  const errors = uploadContactData;
  let isValid = true;
  const groupName = uploadContactData.groupName.value.trim();
  const groupCSV = uploadContactData.groupCSV.value;

  if (!groupName) {
    errors.groupName.error = "Please enter valid group name";
    isValid = false;
  }

  if (!groupCSV.name) {
    errors.groupCSV.error = "Please upload your contact list";
    isValid = false;
  }

  return { isValid, errors };
};

export const expectedColumnNames = [
  "EMAIL_ID",
  "FIRST_NAME",
  "LAST_NAME",
  "CONTACT_NO",
  "POSTAL_CODE",
  "CITY",
  "STATE",
  "COUNTRY",
  "ADDRESS",
  "TIME_ZONE",
  "TAGS",
];

